import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react"
import type { Column } from "@tanstack/react-table"

interface SortableHeaderProps<TData> {
  column: Column<TData, unknown>
  children: React.ReactNode
}

/**
 * A clickable column header for TanStack Table with sort indicators.
 * Click cycles: none -> asc -> desc -> none.
 */
export function SortableHeader<TData>({ column, children }: SortableHeaderProps<TData>) {
  const sorted = column.getIsSorted()

  return (
    <button
      className={`group inline-flex items-center gap-1 transition-colors ${sorted ? "text-foreground" : ""}`}
      onClick={column.getToggleSortingHandler()}
    >
      {children}
      {sorted === "asc" ? (
        <ArrowUp size={12} />
      ) : sorted === "desc" ? (
        <ArrowDown size={12} />
      ) : (
        <ArrowUpDown size={12} className="opacity-0 group-hover:opacity-50 transition-opacity" />
      )}
    </button>
  )
}
